import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconCalendar } from "@pentabd/icons";
import { InputDate, InputText, Text } from "@pentabd/ui";

import { duration } from "@utils/duration";

import {
  ATTACHMENT_POSTING,
  AttachmentPostingFormDataType,
} from "@validations/HRM/employee/postingsValidation";

export const AttachmentPostingForm = ({ id }: { id: string | undefined }) => {
  const { t } = useTranslation();

  const {
    register,
    control,
    watch,
    formState: { errors },
  } = useFormContext<AttachmentPostingFormDataType>();

  let fromDate = watch(ATTACHMENT_POSTING.FROM_DATE);
  let toDate = watch(ATTACHMENT_POSTING.TO_DATE);

  return (
    <div className="d-flex flex-column gap-8">
      <div className="row">
        <div className="col-3">
          <Text size="sm" weight="semibold" className="text-title">
            {t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.POST.LABEL",
            )}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <InputText
            {...register(ATTACHMENT_POSTING.POST)}
            placeholder={t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.POST.PLACEHOLDER",
            )}
            error={errors as any}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-3">
          <Text size="sm" weight="semibold" className="text-title">
            {t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.NAME_OF_THE_OFFICE.LABEL",
            )}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <InputText
            {...register(ATTACHMENT_POSTING.NAME_OF_OFFICE)}
            placeholder={t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.NAME_OF_THE_OFFICE.PLACEHOLDER",
            )}
            error={errors as any}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-3">
          <Text size="sm" weight="semibold" className="text-title">
            {t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.WING.LABEL",
            )}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <InputText
            {...register(ATTACHMENT_POSTING.WING)}
            placeholder={t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.WING.PLACEHOLDER",
            )}
            error={errors as any}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-3">
          <Text size="sm" weight="semibold" className="text-title">
            {t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.DIST_LOCATION.LABEL",
            )}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <InputText
            {...register(ATTACHMENT_POSTING.DIST)}
            placeholder={t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.DIST_LOCATION.PLACEHOLDER",
            )}
            error={errors as any}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-3">
          <Text size="sm" weight="semibold" className="text-title">
            {t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.FROM_DATE.LABEL",
            )}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <Controller
            control={control}
            name={ATTACHMENT_POSTING.FROM_DATE}
            render={({ field }) => (
              <InputDate
                {...register(ATTACHMENT_POSTING.FROM_DATE)}
                name={ATTACHMENT_POSTING.FROM_DATE}
                onSelectDate={(date) => field.onChange(date)}
                value={field.value as string}
                error={errors as any}
                prefix={<IconCalendar size="20" customFill="#667085" />}
                placeholder={t(
                  "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.FROM_DATE.PLACEHOLDER",
                )}
              />
            )}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-3">
          <Text size="sm" weight="semibold" className="text-title">
            {t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.TO_DATE.LABEL",
            )}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <Controller
            control={control}
            name={ATTACHMENT_POSTING.TO_DATE}
            render={({ field }) => (
              <InputDate
                {...register(ATTACHMENT_POSTING.TO_DATE)}
                name={ATTACHMENT_POSTING.TO_DATE}
                onSelectDate={(date) => field.onChange(date)}
                value={field.value as string}
                error={errors as any}
                prefix={<IconCalendar size="20" customFill="#667085" />}
                placeholder={t(
                  "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.TO_DATE.PLACEHOLDER",
                )}
              />
            )}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-3">
          <Text size="sm" weight="semibold" className="text-title">
            {t(
              "EMPLOYEE.POSTINGS_INFO.FORM.ATTACHMENT_POSTING_INFO.DURATION.LABEL",
            )}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <Text color="subtitle2" className="ps-10 fs-md">
            {duration(fromDate as string, toDate as string)}
          </Text>
        </div>
      </div>
    </div>
  );
};
